import scheduleRange from '../../../services/scheduleRange/ScheduleRange'
import i18n from "../../../i18n/index";
export default {
    props: {},
    data: () => ({
        rangeData: [],
        search: "",
        headers: [{
                text: i18n.t('headers.initial'),
                align: 'left',
                sortable: false,
                value: 'start'
            },
            {
                text: i18n.t('headers.final'),
                value: 'end',
                sortable: false
            },
            {
                text: i18n.t('headers.status'),
                sortable: false,
                value: "name"
            }
        ],
    }),
    methods: {
        onRowClick(item) {
            this.$emit('schedule-range', item);
        },
        getScheduleRange() {
            scheduleRange.getScheduleRanges()
                .then(resp => {
                    this.rangeData = resp.data
                })
        },
        handleSheduleRange() {
            alert("handleSheduleRange")
        },
        customFilter(items, search, filter) {
            search = search.toString().toLowerCase()
            return items.filter(row => filter(row["start"], search));
        }
    },
    created() {
        this.getScheduleRange()
    }

}